import { LevelGranulometry } from '../LevelGranulometry';

export const getLevelCeilingHeight = (levelGranulometry: LevelGranulometry): number =>
  levelGranulometry.ceilingHeight;
